/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from 'react'
import { Header, Footer, Loading, Search_Box1 } from '../../../components/index'
import { FiArrowLeft, FiArrowUp, FiArrowDown } from 'react-icons/fi'
import { WebApi } from '../../../api/web'
import { NumberWithCommas } from '../../../utilities/generator'
import { GregorianToJalali2 } from '../../../utilities/convertTime'

const Transaction = () => {
  const [valueSearch, setValueSearch] = useState('')
  const [transactions, setTransactions] = useState(null)

  useEffect(() => {
    Transactions()
  }, [])

  const Transactions = async () => {
    await WebApi.transactions()
      .then((res) => {
        setTransactions(res.data.data.documentPaymentList.documentPayments)
      })
      .catch((err) => {
        console.log('ccc', err)
      })
  }
  const icons = {
    1: <FiArrowLeft size={32} />,
    4: <FiArrowDown size={32} />,
    3: <FiArrowUp size={32} />,
  }
  return (
    <>
      <Header title='تراکنش های مالی' />
      {!transactions && <Loading />}
      <div className='container'>
        <div className='template-pages'>
          {transactions && transactions.length > 0 ? (
            <>
              <Search_Box1 placeholder='نام تراکنش' setState={setValueSearch} />
              {transactions
                .filter((data) => {
                  return data.document.title
                    .toLowerCase()
                    .includes(valueSearch.toLowerCase())
                })
                .map((transaction) => (
                  <div
                    className={`transaction-box status-${transaction.status}`}
                  >
                    <div className='nav'>
                      <div className='icon'>{icons[transaction.status]}</div>
                      <div className='price'>
                        <span>مبلغ</span>
                        <h5>{NumberWithCommas(transaction.amount)} تومان</h5>
                      </div>
                      <div className='data'>
                        <span>در تاریخ</span>
                        <h5>{GregorianToJalali2(transaction.createdAt)}</h5>
                      </div>
                    </div>
                    <div className='nav'>
                      <a
                        href={`/document/${transaction.document._id}`}
                        className='title'
                      >
                        {transaction.document.title}
                      </a>
                      <div className='number'>
                        <span>شماره پرونده</span>
                        <span>{transaction.document.number}</span>
                      </div>
                    </div>
                  </div>
                ))}
            </>
          ) : (
            <h5 className='empty-alert'>هیچ تراکنشی ثبت نشده!</h5>
          )}
        </div>
      </div>
      <Footer />
    </>
  )
}
export default Transaction
